import React from 'react'
import * as components from '../../components'
import * as ReactBootstrap from 'react-bootstrap'
import { EditRepairInventoryItem } from './EditRepairInventoryItem'
import { DeleteRepairInventoryItem } from './DeleteRepairInventoryItem'
import { RepairInventoryItemUseLog } from './RepairInventoryItemUseLog'
import {DeviceWarrantyFormatter} from "../Tickets/DeviceWarrantyFormatter";
import {useSelector} from "react-redux";

const getRowStyle = (item) => {
  const style = {}
  if (item.consumed) {
    style.borderLeft = '10px solid Orange'
    return style
  }
  if (item.blocked) {
    style.borderLeft = '10px solid Red'
    return style
  }
  style.borderLeft = '10px solid Green'
  return style
}
export const RepairInventoryDataGrid = ({
  results,
  page_size,
  current,
  count,
  onFilter,
  handleTableChange,
  children,
  hiddenRowKeys,
  onError,
  getData,
  onDelete,
}) => {
  const { user } = useSelector((state) => state.auth)
  const { role, is_superuser } = user
  const { rights } = useSelector((state) => state.userRights)

  const canDelete=(user && (role === 'SuperUser' || is_superuser || role==="Privileged"))
  const actionFormatter = (cell, row) => {
         const hasManagerRights = rights?.filter(
         x=>x.has_manager_rights && x.organization===row.organization).length>0;

    return (
      <ReactBootstrap.Dropdown>
        <ReactBootstrap.Dropdown.Toggle
          variant="dark"
          size="sm"
        ></ReactBootstrap.Dropdown.Toggle>
        <ReactBootstrap.Dropdown.Menu>
          <EditRepairInventoryItem
            title={'Edit Repair Inventory Entry'}
            onSubmit={getData}
            onError={onError}
            repairInventoryItem={row}
          />
          {canDelete && <DeleteRepairInventoryItem
            onDelete={onDelete}
            onError={onError}
            repairInventoryItem={row}
          />}
          {(canDelete || hasManagerRights) && <DeleteRepairInventoryItem
            onDelete={onDelete}
            onError={onError}
            repairInventoryItem={row}
            text={"Return"}
          />}
          <components.Slider
            size="sm"
            buttonType="dropdown"
            title={
              <span>
                {components.ICONS.SEARCH}
                <span className="pl-3"> History</span>
              </span>
            }
            header={
              <span className="pr-3">
                {components.ICONS.SEARCH}
                <span className="pl-3"> History</span>
              </span>
            }
            sliderWidth={'50vw'}
          >
            <RepairInventoryItemUseLog record={row} />
          </components.Slider>
        </ReactBootstrap.Dropdown.Menu>
      </ReactBootstrap.Dropdown>
    )
  }
  const columns = [
    {
      dataField: 'organization_code',
      searchFieldKey: 'organization',
      text: 'Organization',
      type: 'string',
      searchFieldType: 'text',
    },
    {
      dataField: 'part_number',
      text: 'Part Number',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'serial_number',
      text: 'Serial Number',
      type: 'string',
      formatter: DeviceWarrantyFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'po_number',
      text: 'PO Number',
      hidden: true,
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'awb_number',
      text: 'AWB Number',
      type: 'string',
      hidden: true,
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'description',
      text: 'Description',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
      hidden: true,
    },
        {
      dataField: 'created_by',
      text: 'Created By',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',

    },

    {
      dataField: 'created_at',
      text: 'Created On',
      type: 'string',
      formatter: components.CellDateFormatter,
      searchFieldType: 'date',
    },
    // {
    //   dataField: 'blocked',
    //   text: 'Blocked',
    //   formatter: components.BooleanFormatterWithCSS('blocked', 'text-left'),
    // },
    {
      dataField: 'consumed',
      text: 'Consumed',
      formatter: components.BooleanFormatterWithCSS('consumed', 'text-left'),
    },
      {
      dataField: 'is_cancelled',
      text: 'Returned',
      formatter: components.BooleanFormatterWithCSS('is_cancelled', 'text-left'),
    },
    {
      dataField: 'consignment_type',
      text: 'Consignment Type',
      formatter: components.CellTextFormatter
    },
          {
      dataField: 'url',
      text: 'Change Log',
      formatter: components.ChangeLogFormatter,
    },
    {
      dataField: '',
      text: '',
      isDummyField: true,
      formatter: actionFormatter,
    },
  ]
  return (
    <ReactBootstrap.Card>
      <ReactBootstrap.Card.Header className="card-header bg-dark text-white">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs={6}>Repair Inventory</ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-white text-end" xs={6}>
            <components.Slider
              size="sm"
              title={components.ICONS.SEARCH}
              sliderWidth={"20vw"}
              header={
                <span className="pr-3">
                  {components.ICONS.SEARCH}
                  <span className="pl-3"> Repair Inventory</span>
                </span>
              }
            >
              <components.GenericSearchForm
                onFilter={onFilter}
                columns={columns}
              />
            </components.Slider>

            {children}
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Header>
      <ReactBootstrap.Card.Body>
        <components.DataGrid
          rowStyle={getRowStyle}
          keyField="url"
          data={results || []}
          sizePerPage={page_size || 10}
          current={current || 1}
          page={current}
          columns={columns}
          count={count || 0}
          onTableChange={handleTableChange}
          hiddenRows={hiddenRowKeys}
        />
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}
